<template>
<div class="egl-dialog-elm">
  <el-dialog :title="dialogTitle" :visible="isShow" class="egl-dialog other-purchase-dialog" :modal="false" :before-close="closeDialog" :close-on-click-modal="false">
    <el-form :disabled="disabled" label-position="top">
      <div class="module-item">
        <div class="module-item-tit">{{ $locale("global.basicInfo") }}</div>
        <BasicModule v-if="isShow" v-bind:propForm="form" @setBasicForm="getBasicForm"></BasicModule>
      </div>
      <div class="module-item">
        <div class="module-item-tit">{{ $locale("accountPayable.otherPurchaseDetail") }}</div>
        <OtherPurchaseTable
          v-bind="$attrs"
          v-bind:propData="form.targetSourceList.elseBuy"
          v-bind:cinemaList="cinemaList"
          v-bind:clientList="clientList"
          @callFatherFn="getChildMsg"
          ref="otherTable"
          :actionType="actionType"
        ></OtherPurchaseTable>

        <div class="table-total">
          <div class="clearfix"><span>{{ $locale("accountPayable.differenceFromTheAmountStatedOnTheInvoice") }}</span><span :class="pageTotal != 0 ? 'red-text' : ''">{{ pageTotal.toLocaleString() }}</span></div>
        </div>
      </div>
    </el-form>

    <PaymentTable
      v-if="accountPayableArr.length > 0"
      v-bind:accountPayableArr="accountPayableArr"
      @callFatherPayment="callFatherPayment"
    ></PaymentTable>

    <div slot="footer" class="dialog-footer" v-if="this.actionType != 'view'">
      <el-button class="egl-btn-white" @click="closeDialog">{{ $locale("global.cancel") }}</el-button>
      <el-button :class="saveBtnDisabled ? 'egl-btn-gray' : 'egl-btn-yellow'" @click="save_fn" :disabled="saveBtnDisabled">{{ $locale("global.save") }}</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import OtherPurchaseTable from "./OtherPurchaseTable";
import { createAccountPayable, updateAccountPayable } from "@/helpers/service/api/accountPayable.js";
import { createOtherPurchaseForm, formatOtherPurchaseData, createOtherPurchaseData } from "@/assets/js/accountPayable.js";
import PaymentTable from "./PaymentTable.vue";
import BasicModule from "./BasicModule.vue";
import { mapState } from "vuex";
import { getClientListService } from "@/helpers/service/api/common";

export default {
  name: "AccountPayableOtherPurchase",
  inject: [ "clientList" ],
  data() {
    return {
      form: createOtherPurchaseForm(),
      dialogTitle: "",
      saveBtnDisabled: true,
      childElseBuy: [],
      elseBuyTotal: 0,
      pageTotal: 0,
      disabled: false,
    };
  },
  computed: {
    ...mapState("app", { brandId: state => state.brandId }),
    injectClientList() {
      return this.clientList();
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeFn");
      if (this.actionType === "edit") {
        this.$emit("refreshTable", undefined, false);
      }
    },
    save_fn() {
      const brandId = this.brandId;
      let obj = JSON.parse(JSON.stringify(this.form));
      let tableData = this.$refs.otherTable.getOtherPurchase();

      obj.targetSourceList.elseBuy = tableData.data;
      obj.brandId = brandId;

      if (!obj.id) {
        createAccountPayable(obj).then(res => {
          if (res.success) {
            this.$emit("closeFn");
            this.$emit("refreshTable");
          }
        });
      } else {
        updateAccountPayable(obj).then(res => {
          if (res.success) {
            this.$emit("closeFn");
            this.$emit("refreshTable", this.$locale("global.updateSuccessfully"));
          }
        });
      }
    },
    setSaveBtn() {
      let obj = { ...this.form };
      let saveBtnDisabled = true;
      let pageTotal = 0;
      // let inputNum = parseFloat(this.form.needPayAmount.toString().replace(/[^\d.]/g, "")) || 0;
      let inputNum = isNaN(parseFloat(this.form.needPayAmount.toString())) ? 0 : parseFloat(this.form.needPayAmount.toString());

      inputNum = typeof(inputNum) != "number" && inputNum.length > 0 ? parseFloat(inputNum) : inputNum;
      pageTotal = - inputNum + this.elseBuyTotal;

      if (inputNum == 0 || this.childElseBuy.length == 0 || obj.needPayAmount == "" || obj.name == "") {
        saveBtnDisabled = true;
      } else if (pageTotal == 0) {
        saveBtnDisabled = false;
      }

      this.saveBtnDisabled = saveBtnDisabled;
      this.pageTotal = pageTotal;
    },
    getChildMsg(obj) {
      this.childElseBuy = obj.data;
      this.elseBuyTotal = obj.total;
      this.setSaveBtn();
    },
    getBasicForm(obj) {
      this.form = { ...this.form, ...obj };
      this.setSaveBtn();
    },
    callFatherPayment(index, act) {
      this.$emit("showPaymentRegistration", -1, act, index);
    },
  },
  mounted() {},
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: "",
    },
    cinemaList: {
      type: Array,
      default: () => [],
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    formMsg: {
      type:Object,
      default: () => {},
    },
    accountPayableArr: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    isShow() {
      if (this.isShow) {
        let dialogTitle = "";
        let obj = createOtherPurchaseForm();
        let today = this.$moment().valueOf();
        let disabled = false;
        let saveBtnDisabled = true;
        let elseBuyTotal = 0;
        let pageTotal = 0;

        if (this.actionType == "create" || this.actionType == "registration") {
          obj.requestDeadDate = today;
          obj.payDate = today;
          dialogTitle = this.$locale("accountPayable.otherPurchaseDialogTitle") + this.$locale("global.registration");
        } else if (this.actionType == "edit") {
          dialogTitle = this.$locale("accountPayable.otherPurchaseDialogTitle") + this.$locale("global.edit");
          saveBtnDisabled = false;
          obj = JSON.parse(JSON.stringify(this.formMsg));
          elseBuyTotal = obj.needPayAmount;
        } else {
          dialogTitle = this.$locale("accountPayable.otherPurchaseDialogTitle");
          obj = JSON.parse(JSON.stringify(this.formMsg));
          disabled = true;
        }

        // obj.requestDeadDate = today;
        // obj.payDate = today;

        this.dialogTitle = dialogTitle;
        this.form = obj;
        this.disabled = disabled;
        this.saveBtnDisabled = saveBtnDisabled;
        this.elseBuyTotal = elseBuyTotal;
        this.pageTotal = pageTotal;
        this.childElseBuy = obj.targetSourceList.elseBuy.map(item => item.otherGoodsInfo);

        this.$nextTick(() => {
          this.$refs["otherTable"].$refs["selectV2"].page = 1;
          const tableData = formatOtherPurchaseData(createOtherPurchaseData(this.form.targetSourceList.elseBuy));
          let ids = [];
          tableData.forEach(item => {
            if (item.clientId) {
              ids.push(item.clientId);
            }
          });
          if (ids.length > 0) {
            getClientListService({
              ...ids ? { ids } : {},
              page: 0,
              pageSize: 9999,
              field: ["id", "name"]
            }).then(res => {
              if (res.data && res.data.data.length > 0) {
                this.$refs["otherTable"].comClientList = res.data.data.concat(this.injectClientList);
                // this.$refs["selectV2"].page = 0;
                // if (this.form.targetSourceList.clientIdList.length === 0) this.$refs["selectV2"].page++;
              }
            });
          } else {
            this.$refs["otherTable"].comClientList = this.injectClientList;
          }
        });
      }
    },
  },
  components: {
    OtherPurchaseTable,
    PaymentTable,
    BasicModule,
  },
};
</script>
